import { Box, Typography } from "@material-ui/core";
import { SGSButton } from "components";
import { convertFileToBase64 } from "core/utils/convertFile";
import { postFicherAG2RLidl } from "features/arretTravail/services/lidlDocumentService";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import styles from './DropZone.module.scss';
import LabelAndErrorDropzone from "./labelAndErrorDropzone/LabelAndErrorDropzone";

type Props = {
    label?: string,
    accept: string[]
    width?: string
    height?: string,
    reloadList?: Function
};

//This component is independent it does not use the useFormContext

const SGSDropZone = ({label, accept, width = '700px', height = '100px', reloadList}: Props): JSX.Element => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const [file, setFile] = useState<File>();
    const [loading, setLoading] = useState<boolean>(false);
    const [disabledCancel, setDisabledCancel] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const resetFile = () => {
        setFile(() => null);
        setError(() => null);
        setDisabledCancel(() => true);

        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const handleFileUpload = (file: File) => {
        setError(() => null);

        if (!file) return;

        if(file.type && !accept.includes(file.type)) {
            resetFile();
            setError(() => `Le format du fichier est incorrect.`);
            return;
        };

        if(file.size > 8388608){
            resetFile();
            setError(() => `Le poid maximum d'un fichier et de 8 Mo.`);
            return;
        };

        setFile(() => file);
        setDisabledCancel(() => false);
    };

    const sendDocument = async () => {
        if(!file) return;
        setLoading(() => true);
        setDisabledCancel(() => true);
      
        const fileBase64 = await convertFileToBase64(file);
        const fileBase64Splited = fileBase64.split(',')[1];

        await postFicherAG2RLidl({
            client: 'lidl',
            filename: file.name,
            payload: fileBase64Splited
        })
        .then(() => {
            toast.success('Fichier téléchargé avec succès');

            reloadList && reloadList();
        })
        .catch(() => {
            toast.error('Échec du téléchargement du fichier');
        })
        .finally(() => {
            resetFile();
            setLoading(false);
        });
    };

    const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        handleFileUpload(e.dataTransfer.files[0]);
    };

    return (
        <Box style={{width: width}}>
            <Box 
                className={`${styles.containerUploadFile} ${isDragging ? styles.dragging : ''}`}
                style={{height: height}}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <LabelAndErrorDropzone label={label} file={file} error={error}/>

                <input 
                    ref={fileInputRef}
                    className={styles.inputFile} 
                    type="file" 
                    onChange={(e) => handleFileUpload(e.target.files[0])} 
                    accept={accept.join(',')}
                />
            </Box>

            <Typography color="primary" className={styles.inputFileInfos} variant="body2">
                *Format accepté : .csv | Taille maximale : 8 Mo
            </Typography>

            <Box className={styles.containerBtn}>
                <SGSButton className={styles.marginBtn} type="button" onClick={resetFile} disabled={disabledCancel}>
                    Annuler
                </SGSButton>
                <SGSButton type="button" onClick={sendDocument} disabled={!file} loading={loading}>
                    Envoyer
                </SGSButton>
            </Box>
        </Box>
    );
};

export default SGSDropZone;